import React from 'react'

import { FormikTextInput } from 'components/FormikFields'
import { FieldKit } from 'containers/FormBuilder'
import ConditionTab from 'containers/VehicleSelection/ConditionTab'
import { FormikValues } from 'formik'
import AssetSubtype from 'state/enums/AssetSubtype'

import { ComponentRow, ConditionTabWrapper } from '../MarineWriteIn.styled'
import MakeDropdown from './MakeDropdown'
import { MARINE_CONDITION_ITEMS } from './marineConditionItems'
import YearDropdown from './YearDropdown'

interface Props {
    formik: FieldKit<FormikValues>
    prefilled?: boolean
}

export default function HullCollateralForm({
    formik,
    prefilled,
}: Readonly<Props>) {
    const {
        hull: { condition, year, boatType, make },
    } = formik.values.marine

    return (
        <>
            <ConditionTabWrapper>
                <ConditionTab
                    name="marine.hull.condition"
                    label="Hull Condition"
                    items={MARINE_CONDITION_ITEMS}
                    prefilled={prefilled}
                />
            </ConditionTabWrapper>
            <ComponentRow gridTemplateColumns="125px 180px 1fr">
                <YearDropdown
                    formik={formik}
                    assetSubtype={AssetSubtype.MARINE_HULL}
                    fieldName="marine.hull.year"
                    selectedYear={year}
                    condition={condition}
                    boatType={boatType}
                    label="Hull Year"
                    prefilled={prefilled}
                />
                <MakeDropdown
                    formik={formik}
                    assetSubtype={AssetSubtype.MARINE_HULL}
                    condition={condition}
                    fieldNamePrefix="marine.hull"
                    label="Hull Make"
                    prefilled={prefilled}
                />
                <FormikTextInput
                    name="marine.hull.model"
                    label="Hull Model"
                    disabled={!make}
                    prefilled={prefilled}
                />
            </ComponentRow>
        </>
    )
}
